import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EntityMentions } from './EntityMentions';

export interface ExtendedEpisode {
    _id: string;
    title: string;
    publishedAt: string;
    type?: string;
    url?: string;
    youtubeId?: string;
}
export interface SponsorMention {
    _id: string;
    episodeId: string;
    sponsorId: string;
    startTime: number;
    endTime: number;
    duration: number;
    text: string;
    confidence: number;
    verified: boolean;
    episode: ExtendedEpisode;
    sponsor: {
        _id: string;
        name: string;
        website?: string;
        logo?: string;
        category?: string;
    };
    podcast: {
        _id: string;
        title: string;
        type: 'show' | 'network';
        imageUrl?: string;
        youtubeData?: {
            snippet?: {
                title?: string;
                thumbnails?: {
                    default?: {
                        url: string;
                    };
                };
            };
        };
    };
    analysis?: {
        podcast_context: string;
        brand_entry: string;
        narrative: string;
        tone_language: string;
        functional_message: string;
        brand_repetition: string;
        action_element: string;
        audience_fit: string;
        pacing: string;
        transition_quality: string;
        mention_type: string;
    };
    analyzedAt?: Date;
    createdAt: string;
    updatedAt: string;
}


interface Props {
    mentions: SponsorMention[];
    onTimeClick?: (time: number) => void;
    onAvatarClick?: (mention: SponsorMention) => void;
    showExpandIcon?: boolean;
    showZeroCount?: boolean;
    showSponsors?: boolean;
    showText?: boolean;
    avatarSize?: number;
    maxAvatars?: number;
    enableSponsorLinks?: boolean;
}

export const OriginalSponsorMentions: React.FC<Props> = ({
    mentions,
    onTimeClick,
    onAvatarClick,
    showExpandIcon = true,
    showZeroCount = true,
    showSponsors = true,
    showText = true,
    avatarSize = 40,
    maxAvatars,
    enableSponsorLinks = false,
}) => {
    const navigate = useNavigate();

    const handleAvatarClick = (mention: any) => {
        if (enableSponsorLinks && showSponsors && mention.originalMention?.sponsor?._id) {
            navigate(`/studio/sponsors/${mention.originalMention.sponsor._id}`);
        } else if (onAvatarClick) {
            onAvatarClick(mention.originalMention);
        }
    };

    const transformedMentions = mentions.map(mention => ({
        startTime: mention.startTime,
        endTime: mention.endTime,
        text: mention.text,
        _id: mention._id,
        analysis: mention.analysis
            ? {
                ...mention.analysis,
                mention_type: mention.analysis.mention_type || 'unknown',
            }
            : undefined,
        analyzedAt: mention.analyzedAt ? new Date(mention.analyzedAt) : undefined,
        entity: showSponsors
            ? {
                id: mention.sponsor.name,
                name: mention.sponsor.name,
                imageUrl: mention.sponsor.logo || '',
            }
            : {
                id: mention.podcast._id,
                name:
                    mention.podcast.type === 'show'
                        ? mention.podcast.title || ''
                        : mention.podcast.youtubeData?.snippet?.title || '',
                imageUrl:
                    mention.podcast.type === 'show'
                        ? mention.podcast.imageUrl || ''
                        : mention.podcast.youtubeData?.snippet?.thumbnails?.default?.url || '',
            },
        originalMention: mention,
    }));

    return (
        <EntityMentions
            mentions={transformedMentions}
            onTimeClick={onTimeClick}
            onAvatarClick={handleAvatarClick}
            showExpandIcon={showExpandIcon}
            showZeroCount={showZeroCount}
            emptyText={showSponsors ? 'Sin auspiciadores' : 'Sin podcasts'}
            showText={showText}
            avatarSize={avatarSize}
            maxAvatars={maxAvatars}
        />
    );
};
